import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router} from "@angular/router";
import {Observable, of} from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class EnterGuard implements CanActivate {
    constructor(private router: Router) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        return this.checkEnter(state);
    }

    checkEnter(state: RouterStateSnapshot): Observable<boolean> {
        // let params = state.root.queryParams
        // if(params.arrivalCityCode&&params.departureCityCode&&params.departureDate){
        //     return new Observable<boolean>((obserber)=>{
        //         this.router.navigateByUrl('/airline-list?'+state.url.split('?')[1])
        //         obserber.next(false)
        //         obserber.complete()
        //     })
        // }else{
            return of(true);
        // }
    }
}
